"use client";
import { useI18n } from "@wojo/localization";
import { Button, Container, Text } from "@wojo/ui";
import Link from "next/link";

export function NotFound() {
    const i18n = useI18n("account").account.notFound;

    return (
        <Container
            style={{
                paddingTop: "var(--g-spacing-xl",
                paddingBottom: "var(--g-spacing-xxl",
            }}
            width="full"
        >
            <Text.Heading order="2" tag="h1">
                {i18n.heading.l()}
            </Text.Heading>
            <Text.Body style={{ paddingBottom: "var(--g-spacing-md)" }}>
                {i18n.errCode.l()}
            </Text.Body>
            <Button
                href={i18n.backToAccountBtn.url.l()}
                variant="quiet"
                tag={Link}
            >
                {i18n.backToAccountBtn.text.l()}
            </Button>
        </Container>
    );
}
